// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tournament-next[data-v-2e175d6f] {\n  margin: 0;\n  height: 100%;\n}\n\n.card[data-v-2e175d6f] {\n  background-color: var(--magic-tertiary, #311261);\n}\n\n.link[data-v-2e175d6f] {\n  --magic-text-primary: var(--magic-light, #fff);\n}", ""]);
// Exports
module.exports = exports;
